<script lang="ts" setup>
import { useVoipRoomStore } from '../model/voip-room-store'
import RoomLiveKit from './livekit/RoomLiveKit.vue'
import LessonRoomAlternativeVoip from './lesson-room/LessonRoomAlternativeVoip.vue'
import ClassroomLayout from './ClassroomLayout.vue'

defineOptions({
  name: 'ClassroomPage',
})

const route = useRoute()
const voipRoomStore = useVoipRoomStore()
</script>

<template>
  <ClassroomLayout>
    <LessonRoomAlternativeVoip v-if="voipRoomStore.isAlternativeVoip" />
    <RoomLiveKit
      v-else
      :key="`room-live-kit-${route.params.booking}`"
    />
  </ClassroomLayout>
</template>
